var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'hotMap':_vm.$route.meta.title=='信号热力图'},attrs:{"id":"layout-main"}},[_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }